/**
 * 描述：编辑租户
 * 日期：2017-7-13
 * 作者：Bai Zhiming
 */
'use strict';
angular.module('editTenantModule', [])
    .controller('editTenantCtrl', ['$scope', '$q', 'trsHttpService', '$modalInstance', 'item', '$filter', 'modalDialog', 'permissionService', function($scope, $q, trsHttpService, $modalInstance, item, $filter, modalDialog, permissionService) {
        initStatus();
        initData();

        /**
         * [description]初始化状态
         */
        function initStatus() {
            $scope.status = {
                // whichTabShow: whichTabShow,
                whichTabShow: 0,
                isDate: false,
                isAdmin: false
            };
            $scope.item = item;
            $scope.cdata = {
                customConfig: {
                    drops: 'up',
                }
            };
        }

        /**
         * [getTenantDetail description]获取租户详情
         */
        function getTenantDetail() {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_tenant',
                methodname: 'findTenantById',
                ObjectId: item.TENANTID
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.data = data;
                if (!$scope.data.hasOwnProperty('COMPYRIGHT')) {
                    $scope.data.COMPYRIGHT = '0';
                }
                if ($scope.status.isAdmin) {
                    if (!$scope.data.hasOwnProperty('ATTRIBUTE')) {
                        $scope.data.SHOWXINLANVIDEOLIST = '0';
                    } else {
                        var attribute = $scope.data.ATTRIBUTE.split('&');
                        attribute.map(function(item, index) {
                            if (item.split('=')[0] == 'SHOWXINLANVIDEOLIST') {
                                $scope.data.SHOWXINLANVIDEOLIST = item.split('=')[1];
                            }
                        });
                    }
                }
                var mobileArray = $scope.data.MOBILE.split('-');
                if (mobileArray.length === 2) {
                    $scope.status.areaCode = mobileArray[0];
                    $scope.status.phoneNumber = mobileArray[1];
                } else {
                    $scope.status.areaCode = '';
                    $scope.status.phoneNumber = mobileArray[0];
                }
                deffer.resolve();
            });
            return deffer.promise;
        }

        /**
         * [initData description]初始化数组
         */
        function initData() {
            isAdministrator().then(function() {
                return getTenantDetail();
            }).then(function() {
                return getTenantTypes();
            });
            isTenantAdmin();
        }

        /**
         * [getTenantTypes description]获取行业类型
         */
        function getTenantTypes() {
            var params = {
                serviceid: 'mlf_tenant',
                methodname: 'findIndustryByConfig'
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.status.tenantTypes = (function() {
                    var array = [];
                    for (var i = 0; i < data.length; i++) {
                        array.push({ name: data[i], value: data[i] });
                    }
                    return array;
                })();
                for (var i = 0; i < $scope.status.tenantTypes.length; i++) {
                    if ($scope.status.tenantTypes[i].value === $scope.data.TYPE) {
                        $scope.status.selectedTenantType = angular.copy($scope.status.tenantTypes[i]);
                        break;
                    }
                }
            });

        }

        function isTenantAdmin() {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_tenant',
                methodname: 'CheckIsTenantAdmin'
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.status.isTenantAdmin = data.replace(/\"/g, '') === 'true';
            });
        }

        /**
         * [isAdministrator description] 获取当前用户是否为管理员
         * @return {Boolean} [description]
         */
        function isAdministrator() {
            var deffer = $q.defer();
            permissionService.isAdministrator().then(function(data) {
                $scope.status.isAdmin = data;
                deffer.resolve(data);
            });
            return deffer.promise;
        }

        /**
         * [setXLVideoShow description] 新蓝网视频显示与否保存接口
         */
        function setXLVideoShow() {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_tenant',
                methodname: 'adminSetShowXinlanVideoList',
                TENANTID: item.TENANTID,
                SHOWXINLANVIDEOLIST: $scope.data.SHOWXINLANVIDEOLIST
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                deffer.resolve();
            });
            return deffer.promise;
        }

        /**
         * [selectTenantType description]选择行业类型
         */
        $scope.selectTenantType = function() {
            $scope.data.TYPE = $scope.status.selectedTenantType.value;
        };

        /**
         * [confirm description]提交数据
         */
        $scope.confirm = function() {
            setXLVideoShow().then(function() {
                if ($scope.status.tenantNameRepeat) {return;}
                $scope.dataCopy = angular.copy($scope.data);
                var startTime = new Date($scope.dataCopy.STARTTIME);
                $scope.dataCopy.STARTTIME = startTime.getFullYear() + '-' + (startTime.getMonth() + 1) + '-' + startTime.getDate();
                var endTime = new Date($scope.dataCopy.ENDTIME);
                $scope.dataCopy.ENDTIME = endTime.getFullYear() + '-' + (endTime.getMonth() + 1) + '-' + endTime.getDate();
                // 电话号码提交处理  --start
                $scope.dataCopy.MOBILE = $scope.status.areaCode + '-' + $scope.status.phoneNumber;
                // 电话号码提交处理  --end
                delete $scope.dataCopy.CRTIME;
                delete $scope.dataCopy.CRUSER;
                $scope.dataCopy.ObjectId = $scope.dataCopy.TENANTID;
                delete $scope.dataCopy.TENANTID;
                delete $scope.dataCopy.ATTRIBUTE;
                $scope.dataCopy.serviceid = 'mlf_tenant';
                $scope.dataCopy.methodname = 'updateTenantInfo';
                $scope.dataCopy.ISOPENWANGCHA = $scope.item.ISOPENWANGCHA;
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.dataCopy, 'post').then(function(data) {
                    if (data.TYPE === '3') {
                        modalDialog.alertType('编辑租户成功', '', 'success', false);
                        $modalInstance.close(data);
                    }
                });
            });
        };
        // 取消
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
    }]);
